module.exports = "/_next/static/images/avatar-frame-tier-1-13d606ddd534451b17abad9993f5eb22.png";